import { Users, GraduationCap, Star, Award, BookOpen, Heart, Building2, Calendar, Dumbbell, Droplets, Utensils, Trees, Shield, Wifi, Trophy, Sparkles } from "lucide-react";

const ICONS = {
  Users, GraduationCap, Star, Award, BookOpen, Heart, Building2, Calendar,
  Dumbbell, Droplets, Utensils, Trees, Shield, Wifi, Trophy, Sparkles,
};

export const ICON_NAMES = Object.keys(ICONS);

export function getIcon(name) {
  return ICONS[name] || Star;
}
